// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RestaurantNewDishes_wrapper__OJ9SJ","cards":"RestaurantNewDishes_cards__pDz87","card":"RestaurantNewDishes_card__XWAeU"};